/**
 * Application routes defined here
 */

export default [
  {
    path: "/login",
    view: "Login",
    name: "Login",
    meta: {
      title: "eventPOS Portal | Login",
      AuthNotRequired: true,
    },
  },
  {
    path: "/",
    view: "Home", // Relative to src/views/
    name: "Home",
    meta: {
      title: "eventPOS Portal | Home",
    },
  },
  {
    path: "/AutoLogin",
    view: "Main/AutoLogin",
    name: "AutoLogin",
    meta: {
      title: "eventPOS Portal | AutoLogin",
    },
  },

  {
    path: "/EventDevices",
    view: "EventManagement/Devices/devices",
    name: "EventDevices",
    meta: {
      title: "eventPOS Portal | Event Devices",
    },
  },

  {
    path: "/Devices",
    view: "Devices",
    name: "Devices",
    meta: {
      title: "eventPOS Portal | Devices",
    },
  },

  {
    path: "/device_configuration/:id",
    view: "EventManagement/Devices/deviceImport", // Could delete this route if not used elsewhere
    name: "Device Configuration",
    props: true,
    meta: {
      title: "eventPOS Portal | Device Configuration",
    },
  },

  {
    path: "/device_import/:id",
    view: "EventManagement/Devices/deviceImport",
    name: "Device Import",
    props: true,
    meta: {
      title: "eventPOS Portal | Device Import",
    },
  },

  {
    path: "/ChargebackSearch",
    view: "Main/ChargebackSearch",
    name: "ChargebackSearch",
    meta: {
      title: "eventPOS Portal | Chargeback Search",
    },
  },
  {
    path: "/ClientsEvents",
    view: "Main/ClientsEvents",
    name: "ClientsEvents",
    meta: {
      title: "eventPOS Portal | Clients Events",
    },
  },
  {
    path: "/EventSettings",
    view: "Main/EventSettings",
    name: "EventSettings",
    meta: {
      title: "eventPOS Portal | Event Settings",
    },
  },
  {
    path: "/DashboardUsers",
    view: "Admin/DashboardUsers",
    name: "DashboardUsers",
    meta: {
      title: "eventPOS Portal | Dashboard Users",
    },
  },
  {
    path: "/DashboardGroups",
    view: "Admin/DashboardGroups",
    name: "DashboardGroups",
    meta: {
      title: "eventPOS Portal | Dashboard Groups",
    },
  },
  {
    path: "/TsgAdmins",
    view: "Admin/TsgAdmins",
    name: "TsgAdmins",
    meta: {
      title: "eventPOS Portal | TSG Admins",
    },
  },
  {
    path: "/PortalUsers",
    view: "Admin/DashboardUsers",
    name: "PortalUsers",
    meta: {
      title: "eventPOS Portal | Dashboard Users",
    },
  },
  {
    path: "/PortalGroups",
    view: "Admin/DashboardGroups",
    name: "PortalGroups",
    meta: {
      title: "eventPOS Portal | Dashboard Groups",
    },
  },
  {
    path: "/Products",
    view: "Main/Products",
    name: "Products",
    meta: {
      title: "eventPOS Portal | Products",
    },
  },
  {
    path: "/ProductSales",
    view: "ProductSales",
    name: "ProductSales",
    meta: {
      title: "eventPOS Portal | Product Sales",
    },
  },
  {
    path: "/Administration",
    view: "Main/Administration",
    name: "Administration",
    meta: {
      title: "eventPOS Portal | Admin",
    },
  },
  {
    path: "/ProductStoresStockLevels",
    view: "Main/ProductStoresStockLevels",
    name: "ProductStoresStockLevels",
    meta: {
      title: "eventPOS Portal | Product Stores Stock Levels",
    },
  },
  {
    path: "/SourceProductsMappings",
    view: "Main/SourceProductsMappings",
    name: "SourceProductsMappings",
    meta: {
      title: "eventPOS Portal | Source Products Mappings",
    },
  },
  {
    path: "/EventManagement",
    view: "Main/EventManagement",
    name: "EventManagement",
    meta: {
      title: "eventPOS Portal | Event Management",
    },
  },
  {
    path: "/ProductManagement",
    view: "Main/ProductManagement",
    name: "ProductManagement",
    meta: {
      title: "eventPOS Portal | Product Management",
    },
  },
  {
    path: "/StockLevels",
    view: "StockLevels",
    name: "StockLevels",
    meta: {
      title: "eventPOS Portal | Stock Levels",
    },
  },
  {
    path: "/Takings",
    view: "Takings",
    name: "Takings",
    meta: {
      title: "eventPOS Portal | Takings",
    },
  },
  {
    path: "/Transactions",
    view: "Transactions",
    name: "Transactions",
    meta: {
      title: "eventPOS Portal | Transactions",
    },
  },
  {
    path: "/VoucherSetup",
    view: "Main/VoucherSetup",
    name: "VoucherSetup",
    meta: {
      title: "eventPOS Portal | VoucherSetup",
    },
  },

  {
    path: "/event_configuration/:id",
    view: "EventManagement/Events/eventConfiguration",
    name: "Event Configuration",
    props: true,
    meta: {
      title: "eventPOS Portal | Event Configuration",
    },
  },

  // {
  //   path: "/stallholder_configuration",
  //   view: "EventManagement/Stallholders/stallholderConfiguration",
  //   name: "Stallholders Configuration",
  //   meta: {
  //     title: "eventPOS Portal | Stallholders Configuration",
  //   },
  // },

  // {
  //   path: "/user_configuration",
  //   view: "EventManagement/Users/userConfiguration",
  //   name: "User Configuration",
  //   meta: {
  //     title: "eventPOS Portal | User Configuration",
  //   },
  // },

  {
    path: "/stall_configuration/:id",
    view: "EventManagement/Stalls/stallConfiguration",
    name: "Stall Configuration",
    props: true,
    meta: {
      title: "eventPOS Portal | Stall Configuration",
    },
  },

  {
    path: "/tag_configuration/:id",
    view: "EventManagement/Tags/tagConfiguration",
    name: "Tag Configuration",
    props: true,
    meta: {
      title: "eventPOS Portal | Tag Configuration",
    },
  },

  {
    path: "/terminal_configuration/:id",
    view: "EventManagement/Terminals/terminalConfiguration",
    name: "Terminal Configuration",
    props: true,
    meta: {
      title: "eventPOS Portal | Terminal Configuration",
    },
  },

  {
    path: "/layout_configuration/:id",
    view: "ProductManagement/Layouts/LayoutConfiguration",
    name: "Layout Configuration",
    props: true,
    meta: {
      title: "eventPOS Portal | Layout Configuration",
    },
  },
];
